'use client'

import { useEffect } from 'react'
import { useScript } from '@phoenix-web/react-hooks'

const TRUSTPILOT_SCRIPT = '//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js'

// Extend Window interface to include Trustpilot
declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: Element | null) => void
    }
  }
}

export default function TrustpilotWidget() {
  const script = useScript(TRUSTPILOT_SCRIPT)
  useEffect(() => {
    if (script === 'ready' && typeof window !== 'undefined' && window.Trustpilot) {
      window.Trustpilot.loadFromElement(document.querySelector('.trustpilot-widget'))
    }
  }, [script])

  return (
    <div
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="5419b637fa0340045cd0c936"
      data-businessunit-id="5ca3631dd888850001a041b6"
      data-style-height="20px"
      data-style-width="100%"
      data-token="fc0510e5-7b37-4285-861f-bbe19ad0e83d"
    ></div>
  )
}
